import axios from '~/utils/request'

export function login(data) {
  return axios({
    method: 'post',
    url: '/api/Token/Login',
    data
  })
}

export function updatePwd(data) {
  return axios({
    method: 'post',
    url: '/api/Token/ChangePassword',
    data
  })
}

export function createUser(data) {
  return axios({
    method: 'post',
    url: '/api/UserManager/CreateUser',
    data
  })
}

export function updateUser(data) {
  return axios({
    method: 'put',
    url: '/api/UserManager/EditUser',
    data
  })
}

export function deleteUser(params) {
  return axios({
    method: 'delete',
    url: '/api/UserManager/DeleteUser?id=' + params.id,
  })
}

export function getUserInfo(params) {
  return axios({
    method: 'get',
    url: '/api/UserManager/GetUserInfoPage',
    params: params
  })
}

export function getCurrentUserInfo(params) {
  return axios({
    method: 'get',
    url: '/api/UserManager/GetCurrentUserInfo',
    params: params
  })
}

export function resetPassword(params) {
  return axios({
    method: 'put',
    url: '/api/UserManager/ResetPassword',
    params: params
  })
}

export function getAppraiserInfo(params) {
  return axios({
    method: 'get',
    url: '/api/UserManager/GetUserInfoZiXunShiPage',
    params: params
  })
}
